import axios from '../axiosCall'
import Urls from "../endpoints";
import { IChangeFactorTypeToRevokeOrReturn, IGetAllInvoice, IGetAllInvoiceReserved, IGetInvoiceReservedById, IGetMoadianLog, IGetNewStatusAllMovadianInvoice, IGetOfficialFactorLists, IInsertInvoice, IResendInvoice, IupdateOfficialFactors, IUpdateReservedFctorForMoadian } from '../modelAPI/invoice';
import '../modelAPI/invoice'
import { GetMoadianLogResponse } from '../resultAPI/getMoadianLogResponse';
import { IResponse } from '../resultAPI/response';
import { IGetOfficialFactorListsResponse } from '../resultAPI/getOfficialFactorListsResponse';
import { IResendInvoiceResponse } from '../resultAPI/resendInvoiceResponse';
import { IGetAllInvoiceResponse } from '../resultAPI/getAllInvoiceResponse';
import { INserInvoice } from '../resultAPI/insertInvoiceResponse';
import { IChangeFactorTypeToRevokeOrReturnResponse } from '../resultAPI/changeFactorTypeToRevokeOrReturnResponse';
import { IGetReturnedOrRevokedFactorsResponse } from '../resultAPI/getReturnedOrRevokedFactorsResponse';
import { IGetFinancialPeriodsResponse } from '../resultAPI/GetFinancialPeriodsResponse';
import { IGetAllInvoiceReservedResponse } from '../resultAPI/getAllInvoiceResevedResponse';
// import { IGetAllInvoiceReservedResponse } from '../resultAPI/getAllInvoiceReservedResponse';





export const getMoadianLog = (obj: IGetMoadianLog) => {
    return axios.post<GetMoadianLogResponse[]>(Urls.GetMoadianLog(), obj)

}
export const updateReservedFactorForMoadian = (obj: IUpdateReservedFctorForMoadian) => {
    return axios.post<IResponse>(Urls.UpdateReservedFactorForMoadian(), obj)
}
export const resendInvoice = (id: IResendInvoice) => {
    return axios.get<IResendInvoiceResponse>(Urls.ResendInvoice(id))
}
export const getNewStatusAllMovadianInvoice = (obj: IGetNewStatusAllMovadianInvoice) => {
    return axios.post<boolean|string>(Urls.GetNewStatusForAllPendingRequest(), obj)
}
export const getAllInvoice = (obj: IGetAllInvoice) => {
    return axios.post<IGetAllInvoiceResponse>(Urls.GetAllInvoiceNumber(), obj)
}
export const insertInvoice = (dataList: IInsertInvoice) => {
    return axios.post<INserInvoice[]>(Urls.insertInvoice(), dataList)
}
export const getAllInvoiceReserved = (obj: IGetAllInvoiceReserved) => {
    return axios.post<IGetAllInvoiceReservedResponse>(Urls.getOfficialFactorLists(), obj)
}
export const getReturnedOrRevokedFactors = (obj: IGetAllInvoiceReserved) => {
    return axios.post<IGetReturnedOrRevokedFactorsResponse>(Urls.getReturnedOrRevokedFactors(), obj)
}
export const changeFactorTypeToRevokeOrReturn = (obj: IChangeFactorTypeToRevokeOrReturn) => {
    return axios.post<IChangeFactorTypeToRevokeOrReturnResponse>(Urls.changeFactorTypeToRevokeOrReturn(), obj)
}
export const getInvoiceReservedById = (obj: IGetInvoiceReservedById) => {
    return axios.post<IGetAllInvoiceReservedResponse>(Urls.getOfficialFactorLists(), obj);
}
export const updateOfficialFactors = (dataList: IupdateOfficialFactors[]) => {
    return axios.put<IResponse>(Urls.UpdateOfficialFactors(), dataList);
}
export const GetFinancialPeriods = () => {
    return axios.get<IGetFinancialPeriodsResponse>(Urls.GetFinancialPeriods());
}



